/* ============================================================================
   tne-materiais.js — Biblioteca de PDFs (/pages/portal-materiais)
   DistribuidorTopBioEuropa | Site institucional B2B

   Apenas inicializa o filtro por categoria. Os cards são links directos
   para o PDF (target=_blank) — sem necessidade de player nem tracking.

   Reaproveita classes .tne-portal__filtros / .tne-filtro / .is-active.
   ============================================================================ */

(function () {
  'use strict';

  function initFilters() {
    var filtros = document.querySelector('[data-tne-materiais-filtros]');
    if (!filtros) return;

    var btns = filtros.querySelectorAll('.tne-filtro');
    var cards = document.querySelectorAll('.tne-material-card');
    var emptyMsg = document.querySelector('[data-tne-materiais-empty]');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var alvo = btn.getAttribute('data-filtro') || 'todos';

        btns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        var visiveis = 0;
        cards.forEach(function (card) {
          var cat = card.getAttribute('data-categoria') || 'outros';
          var match = alvo === 'todos' || cat === alvo;
          card.classList.toggle('is-filtrado-out', !match);
          if (match) visiveis++;
        });

        if (emptyMsg) emptyMsg.hidden = visiveis !== 0;
      });
    });
  }

  function init() {
    var grid = document.getElementById('tne-materiais-grid');
    if (!grid) return;
    initFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
